<app-dialog-base class="modalobjectslist" [Title]='title |translate' [dialogId]="dialogId" (onClose)="close()"
  (onSubmit)="submit()">
  <div class="searchbox">
    <app-group-filter class="objects-management-group-filter" *ngIf="groups.length > 0" [groups]="groups" [isEditable]="false"
      (onSelectGroup)="selectGroup($event)">
    </app-group-filter>
  </div>
  <div class="searchbox-second-row" [class.company-hidden]="!showCompanyFilterAndColumn">
    <p-multiselect *ngIf="showCompanyFilterAndColumn"
      [options]="companies" [ngModel]="filter.companyIds" (ngModelChange)="onCompanyFilterChange($event)"
      optionLabel="Name" optionValue="Id" [filter]="true" filterBy="Name" [showClear]="true" [appendTo]="'body'"
      styleClass="objects-company-multiselect" panelStyleClass="objects-company-multiselect-panel"
      [placeholder]="'All companies' | translate"></p-multiselect>
    <input class="searchinput" type="text" placeholder="{{'Find by name' | translate }}"
      (input)="onTermChange($event)" />
  </div>
  <div class="objects-list-wrap">
    <div class="loading-overlay" *ngIf="isLoading">
      <div class="spinningCircle"></div>
      <div class="loading-label">{{'Loading...' | translate}}</div>
    </div>
    <p-table class="objects-list-table" [value]="filteredObjects" [scrollable]="true" scrollHeight="flex" dataKey="Id"
      [tableStyle]="{ 'width': '100%', 'table-layout': 'fixed' }" [rowTrackBy]="trackByObjectId" [paginator]="true"
      [rows]="20" [rowsPerPageOptions]="pageSizeOptions" [paginatorDropdownAppendTo]="'body'"
      [resizableColumns]="true" columnResizeMode="fit">
      <ng-template pTemplate="colgroup">
        <colgroup *ngIf="showCompanyFilterAndColumn; else noCompanyColgroup">
          <col style="width: 32px" />
          <col />
          <col style="width: 180px" />
        </colgroup>
      </ng-template>
      <ng-template #noCompanyColgroup>
        <colgroup>
          <col style="width: 32px" />
          <col />
        </colgroup>
      </ng-template>
      <ng-template pTemplate="header">
        <tr>
          <th class="objects-list-checkbox-cell">
            <switch-all-checkbox [items]="filteredObjects" *ngIf="!isSingleItem" />
          </th>
          <th class="objects-list-name-cell" pSortableColumn="Name" pResizableColumn>
            {{'Name'|translate }}
            <p-sortIcon field="Name"></p-sortIcon>
          </th>
          <th *ngIf="showCompanyFilterAndColumn" class="objects-list-company-cell" pSortableColumn="CompanyId" pResizableColumn>
            {{'Company'|translate }}
            <p-sortIcon field="CompanyId"></p-sortIcon>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-object>
        <tr>
          <td class="objects-list-checkbox-cell">
            <input *ngIf="object.CanSelect !== false" type="checkbox" [(ngModel)]="object.IsChecked"
              (change)="onToggle(object)" />
          </td>
          <td class="objects-list-name-cell">{{object.Name}}</td>
          <td *ngIf="showCompanyFilterAndColumn" class="objects-list-company-cell">{{resolvedCompanyLookup[object.CompanyId] || ''}}</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</app-dialog-base>
